import { useEffect, useState } from "react";
import { Configuration } from "../context/ConfigurationContext";
import { useConnection } from "../context/ConnectionContext";
import { getExitVelocity, getLaunchAngle, getPitchType, getSpeed, InformationLabels } from "../util/InformationUtil";

export type useAdditionalInformationType = {
  primary: string;
  primaryLabel: string;
  secondary: string;
  secondaryLabel: string;
};

const useAdditionalInformation = (config: Configuration): useAdditionalInformationType => {
  const { pitch } = useConnection();

  const [primary, setPrimary] = useState<string>("");
  const [primaryLabel, setPrimaryLabel] = useState<string>("");
  const [secondary, setSecondary] = useState<string>("");
  const [secondaryLabel, setSecondaryLabel] = useState<string>("");

  useEffect(() => {
    if (!!pitch) {
      if (pitch.inPlay) {
        if (config.display.showExitVelocity && !!pitch.exitVelocity) {
          setPrimary(getExitVelocity(pitch));
          setPrimaryLabel(InformationLabels.exitVelocity);
        } else if (config.display.showPitchSpeed) {
          setPrimary(getSpeed(pitch));
          setPrimaryLabel(InformationLabels.pitchSpeed);
        } else {
          setPrimary(InformationLabels.empty);
          setPrimaryLabel(InformationLabels.empty);
        }
        if (config.display.showLaunchAngle && !!pitch.launchAngle) {
          setSecondary(getLaunchAngle(pitch));
          setSecondaryLabel(InformationLabels.launchAngle);
        } else if (config.display.showPitchType) {
          setSecondary(getPitchType(pitch));
          setSecondaryLabel(InformationLabels.pitchType);
        } else {
          setSecondary(InformationLabels.empty);
          setSecondaryLabel(InformationLabels.empty);
        }
      } else {
        if (config.display.showPitchSpeed) {
          setSecondary(getSpeed(pitch));
          setSecondaryLabel(InformationLabels.pitchSpeed);
        }
        if (config.display.showPitchType) {
          setPrimary(getPitchType(pitch));
          setPrimaryLabel(InformationLabels.pitchType);
        }
      }
    } else {
      setPrimary(InformationLabels.empty);
      setPrimaryLabel(InformationLabels.empty);
      setSecondary(InformationLabels.empty);
      setSecondaryLabel(InformationLabels.empty);
    }
  }, [pitch, config.display]);

  return {
    primary,
    primaryLabel,
    secondary,
    secondaryLabel,
  };
};

export default useAdditionalInformation;
